const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getLeadById = async (leadId, role) => {
    const token = localStorage.getItem('token');

    if (!token) {
        console.error('[getLeadById] Ошибка: Токен авторизации не найден.');
        // throw new Error('Токен авторизации не найден.');
    }

    try {
        const response = await fetch(
            `${API_BASE_URL}/${role}/lead/leads/${leadId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error(`[getLeadById] Ошибка получения лида ${leadId}:`, errorData);
            throw { ...errorData, statusCode: response.status };
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error(`[getLeadById] Ошибка сети или другая ошибка при получении лида ${leadId}:`, error);
        throw error;
    }
};